/**
 * LogPlaceholder — factory voor "nog te bouwen" logging-tegels.
 *
 * De Logging-tab toont echte logs voor functies die de render-server gebruiken.
 * Voor functies die (nog) geen logging hebben tonen we een pseudo-sectie die
 * geen data laadt maar duidelijk maakt dat deze logging nog gebouwd moet worden.
 *
 * Gebruik in de sectie-catalogus:
 *   component: makeLogPlaceholder('Recorder logs', 'Transcripties en uploads…')
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { Construction as ConstructionIcon } from '@mui/icons-material';
import { T, SectionHeader } from '../adminSettingsCommon';

export function makeLogPlaceholder(title, subtitle) {
  return function LogPlaceholder() {
    return (
      <Box>
        <SectionHeader title={title} subtitle={subtitle} />
        <Box sx={{
          mt: 2, p: 6, textAlign: 'center', bgcolor: T.surface,
          borderRadius: '0.7rem', border: `1px dashed ${T.outlineVariant}`,
        }}>
          <ConstructionIcon sx={{ fontSize: 40, color: T.outlineVariant, mb: 1 }} />
          <Typography sx={{ fontFamily: T.font, fontSize: '1rem', fontWeight: 800, color: T.secondary, mb: 0.5 }}>
            Nog te bouwen
          </Typography>
          <Typography sx={{ fontFamily: T.fontBody, fontSize: '0.85rem', color: T.outline, maxWidth: 420, mx: 'auto' }}>
            Deze functie gebruikt (nog) niet de render-server. De logging hiervoor
            moet nog gebouwd worden — dit is een placeholder zodat de plek
            alvast gereserveerd is.
          </Typography>
        </Box>
      </Box>
    );
  };
}
